"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextArea = exports.Search = exports.Password = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _Input = require("./Input.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 文字輸入匡
 */

const Input = _ref => {
  let {
    label,
    message,
    onChange,
    placeholder,
    value,
    icon,
    onKeyEnter,
    row = false,
    maxLength,
    disabled,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, {
    className: className,
    row: row
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: icon && /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, icon),
    allowClear: true,
    onPressEnter: onKeyEnter,
    maxLength: maxLength,
    disabled: disabled
  }), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};
const TextArea = _ref2 => {
  let {
    label,
    message,
    onChange,
    placeholder,
    value,
    disabled,
    maxLength
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input.TextArea, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    autoSize: {
      minRows: 3,
      maxRows: 5
    },
    allowClear: true,
    disabled: disabled,
    maxLength: maxLength
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputInfo"
  }, message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message), maxLength && /*#__PURE__*/_react.default.createElement("div", {
    className: "count"
  }, value.length, "/", maxLength)));
};
exports.TextArea = TextArea;
const Search = _ref3 => {
  let {
    onChange,
    onSearch = () => {},
    placeholder,
    value,
    mode,
    disabled
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, {
    className: mode
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    onChange: onChange,
    onSearch: onSearch,
    placeholder: placeholder,
    value: value,
    suffix: /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "search"),
    allowClear: true,
    disabled: disabled
  }));
};
exports.Search = Search;
const Password = _ref4 => {
  let {
    label,
    message,
    onChange,
    placeholder,
    value,
    disabled
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_Input.UiInput, null, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Input.Password, {
    onChange: onChange,
    placeholder: placeholder,
    value: value,
    prefix: /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock_outline"),
    iconRender: visible => visible ? /*#__PURE__*/_react.default.createElement(_icons.EyeTwoTone, null) : /*#__PURE__*/_react.default.createElement(_icons.EyeInvisibleOutlined, null),
    allowClear: true,
    disabled: disabled
  }), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};
exports.Password = Password;
var _default = exports.default = Input;
Input.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  icon: _propTypes.default.string,
  onKeyEnter: _propTypes.default.func,
  row: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
TextArea.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  maxLength: _propTypes.default.number
};
Search.propTypes = {
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  mode: _propTypes.default.oneOf(["default", "dark"]),
  disabled: _propTypes.default.bool
};
Password.propTypes = {
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool
};